import React, {useEffect, useState} from 'react';
import './eventPage.css'
import PageHeader from "../../layouts/home/PageHeader";
import {Container, Row, Col, Image} from "react-bootstrap";
import DOMPurify from "dompurify";
import {useParams} from "react-router-dom";
import apiRequest from "../../services/Axios/Configs/configs";

function EventPage(props) {

    const {id} = useParams('id')
    const [safeHtml, setSafeHtml] = useState()
    const[event, setEvent] = useState({})

    const isEmpty = (obj) => !obj || Object.keys(obj).length === 0;

    useEffect(() => {
        apiRequest.get(`event/${id}/`).then(response => {
            setEvent(response.data)
        })
            .catch(error => console.error(error));
    }, []);


    if(isEmpty(event)) return null;
    return (
        <>
            <section>
                <PageHeader mainTitle={'رویداد'} currentPage={'رویداد'}
                            navigationLinks={[{title: 'صفحه اصلی', href: '/'}, {title: 'رویدادها', href: '/events'}]}/>
            </section>
            <section className={'content-section'}>
                <Container className={'event-content p-5'}>
                    <Row>
                        <Col lg={6} className={'d-flex justify-content-center mb-lg-0 mb-3'}>
                            <div>
                                <div className="image-wrapper">
                                    <Image
                                        src={event.image}
                                        className="poster-image"
                                        alt="poster image"
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className={'mt-lg-0 mt-5'}>
                            <h1 className={'event-title'}>{event.title}</h1>
                            <div className={'finished-event-page-detail-wrapper my-4'}>
                            <p className={'m-0'}>تاریخ رویداد: <span className={'d-flex flex-row-reverse me-2'}>{event.event_date}</span></p>
                                {/*<Link to={'/'}>برنامه نویسی</Link>*/}
                            </div>
                            <div className="finished-event-page-description"
                                 dangerouslySetInnerHTML={{__html: event.description}}>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}

export default EventPage;


/*
<div className={'event-page-detail-wrapper my-4'}>
    <p className={'m-0'}>تاریخ رویداد: 1402/05/03</p>
    {/!*<Link to={'/'}>برنامه نویسی</Link>*!/}
</div>
<div className="event-page-description-wrapper">
    <h1 className={'mb-4'}>برنامه نویسی چیست؟ و برنامه نویسان چه مهارت هایی باید داشته
        باشند؟</h1>
    <div className="event-page-description" dangerouslySetInnerHTML={{__html: safeHtml}}>
    </div>
</div>*/
